<template>
    <div id="fileAccessEditRulePanel" class="form-wrapper" >

        <PanelDropdown v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :formType="formType" :tooltip="$t('tooltips.shared.folderMap')" :disabled="isFormReadOnly" />
        <FolderFileName v-model="localForm.fileName" :max-length="260" :titleLabel="$t('folderFileName')" :placeholder="$t('enterfolderFileName')" :tooltip="$t('tooltips.shared.folderFileName')" :disabled="isFormReadOnly" @validation="onValidation" />
        
            <PanelDropdown v-model="localForm.accessControl" :label="$t('accessControl')" :options="accessControlOptions"
                placeholder="None" :formType="formType" :tooltip="$t('tooltips.fileAccess.accessControl')" style="padding-top: 10px; width: 74%;" :disabled="isFormReadOnly"/>
            
            <div class="control-warning d-flex align-items-center" v-if="showLinkedProcessButton">
            <div class="col-8 d-flex">
                <i class="ag-icon ag-icon_info_yellow small yellow-info"></i>
                <span>{{ $t('accessControlManagedInProcessTab') }}</span>
            </div>
            <button v-if="showLinkedProcessButton" type="button" class="link-text-button col-4"
                @click="onLinkedProcess">
                {{ $t('editInProcessTab') }}
                <i class="ag-icon ag-icon_openNewPage"></i>
            </button>
        </div>

        <div class="d-flex">
            <div class="d-flex col-5" style="padding-left: 0px !important;">
                <label class="form-label ">{{ $t('auditCreateOperations') }} </label>
                <Tooltip :text="$t('tooltips.fileAccess.auditCreateOperations')"><i
                        class="ag-icon ag-icon_table_info small info-icon"></i></Tooltip>

            </div>

            <div class="col-7">
                <ToggleSwitch v-model="localForm.auditCreateOperations" label="" :show-info="false" />
            </div>
        </div>
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" :label="$t('notes')"/>

    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import ToggleSwitch from './components/toggle-switch.vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import ExpertNotes from './components/expertNotes.vue';
import { useStore } from "@/store";
import Tooltip from './components/tooltip.vue'
import FolderFileName from './components/folderFileName.vue';
import { AppGroupTypes } from '@/helpers/enums/AppGroupTypes'
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'fileAccess'
    },
    enumKey: {
        type: String,
        default: 'AccessControl'
    },
});

const emit = defineEmits(['update:form','validation','linkedProcess'])
const templatePolicy = ref(false);
const routeName = useRoute().name;
if (routeName == 'templateAppGroupDetail') {
    templatePolicy.value = true;
}
async function onLinkedProcess(){
    const group = localStorage.getItem("agms_group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
  const ruleGuid = props.form?.ruleGuid ?? null;
  emit('linkedProcess', { groupId, ruleGuid, form: props.form });
}

const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});
const accessControlOptions = computed(() => {
    return store.state.general.enums[props.enumKey] || [];
});

const processId = computed(() => {
    const pid = localForm.value?.processId
    return pid !== null && pid !== undefined && pid !== 0
})

const isFormReadOnly = computed(() => processId.value)

const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

function onValidation(valid){
    emit('validation', valid)
}

const folderMap = computed({
    get() {
        return localForm.value.isFolderMapIdAny ? -1 : localForm.value.folderMapId;
    },
    set(val) {
        if (val === -1) {
            localForm.value.isFolderMapIdAny = true;
            localForm.value.folderMapId = -1;
        } else if (val === null) {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = null;
        } else {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = val;
        }
    },
});

const showLinkedProcessButton = computed(() => {
    return isFormReadOnly.value
})

</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 6px;
    display: inline-flex;
    align-items: center;
}

.link-text-button {
    background: transparent;
    border: none;
    color: #0055A6;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    font-size: 12px;
    margin-left: 12px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    
}
.link-text-button .ag-icon {
  margin-left: 6px;
}
.control-warning {
  border: 1px solid #FAC812;
  padding: 4px 10px;
  background-color: #FFF9E7;
  color: #000000;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 1fr auto;
}
.yellow-info {
  margin-right: 5px; 
  margin-top: 2px;
  width: 24px;
  height: 12px  ;
}

</style>
